import React, { useCallback, useEffect, useState, createContext } from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'

const ToastContext = createContext()

export default ToastContext

export const notificationTypes = {
  success: 'success',
  warning: 'warning',
  error: 'error',
}

export function ToastContextProvider({ children }) {
  const [toastOpen, setToastOpen] = useState(false)
  const [toastType, setToastType] = useState('success')
  const [toastMsg, setToastMsg] = useState('')

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
  }

  const addToast = useCallback((type, msg) => {
    setToastOpen(true)
    setToastType(type)
    setToastMsg(msg)
  })

  const handleClose = () => {
    setToastOpen(false)
  }
  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={toastOpen}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          severity={toastType}
          style={{
            margin: '0 40px',
            fontSize: '20px',
            fontWeight: 'bold',
            alignItems: 'center',
          }}
          onClose={handleClose}
        >
          {toastMsg}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  )
}
